exports = module.exports = require("../../../build/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ui-label-prestige-icon{display:inline-block;vertical-align:middle;width:15px;height:15px;background-size:100%;background-repeat:no-repeat;background-position:50%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!../src/ui/label/prestige-icon.vue
// module id = 551
// module chunks = 0 1 2 3